import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox", "allocationWarning", "allWarning"]

  connect() {
    this.updateWarnings()
  }

  update() {
    this.updateWarnings()
  }

  updateWarnings() {
    const checkboxes = this.checkboxTargets
    const checked = checkboxes.filter(cb => cb.checked)

    // Identify Allocation / Standing Orders checkbox
    const allocationCheckbox = checkboxes.find(cb =>
      cb.dataset.groupName === "Standing Orders"
    )

    // Allocation warning
    if (allocationCheckbox && !allocationCheckbox.checked) {
      this.allocationWarningTarget.classList.remove("hidden")
    } else {
      this.allocationWarningTarget.classList.add("hidden")
    }

    // All unchecked warning
    if (checked.length === 0) {
      this.allWarningTarget.classList.remove("hidden")
    } else {
      this.allWarningTarget.classList.add("hidden")
    }
  }
}